
import { call, put, takeEvery } from 'redux-saga/effects'

import { createActionTypes } from '../common/client/sagas/common';
import { ERROR_CLEAR_ACTION_TYPE, ERROR_CREATE_ACTION_TYPE } from '../common/client/sagas/operationStatus';
import getPromiseCallback from '../common/client/utils/getPromiseCallback';

export const CLEAR_PROJECT_LIST_ACTION_TYPE = 'project/CLEAR_PROJECT_LIST';
export const GET_PROJECT_LIST_ACTION_TYPE = createActionTypes('project/GET_PROJECT_LIST');

function getProjectList(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callGet({
            module: 'project',
            name: 'getProjectList',
            token: action.token,
            callback: getPromiseCallback(
                resolve, reject, {
                    responseSelector: ''
                }
            )
        });
    });
}

function* workGetProjectList(options, action) {
    try {
        yield put({type: ERROR_CLEAR_ACTION_TYPE});
        yield put({type: GET_PROJECT_LIST_ACTION_TYPE.LOADING});
        const data = yield call(getProjectList, options.serverApi, action);
        yield put({type: GET_PROJECT_LIST_ACTION_TYPE.SUCCESS, data});
    } catch (error) {
        yield put({type: GET_PROJECT_LIST_ACTION_TYPE.FAILED, error});
        yield put({type: ERROR_CREATE_ACTION_TYPE, error});
    }
}

export function* watchGetProjectList(options) {
    yield takeEvery(GET_PROJECT_LIST_ACTION_TYPE.DEFAULT, workGetProjectList, options);
}